export const MANAGEMENT_MODULE_ID = "management-practice-module-id";
export const STORIES_MODULE_ID = "cmavrcqxc00001yi1ks3mt3wm";
export const SCRIPT_GENERATOR_MODULE_ID = "script-generator-module-id";

export function isManagementModuleId(moduleId) {
  return String(moduleId || "") === MANAGEMENT_MODULE_ID;
}
